import {Component, OnInit} from '@angular/core';
import {AuthService} from '../services/auth.service';

@Component({
  templateUrl: './super-market-budget.component.html'
})
export class SuperMarketBudgetComponent implements OnInit {
  constructor(private authService: AuthService) {
  }

  public user: any;

  public async ngOnInit(): Promise<any> {
    this.user = await this.authService.getUser();
  }

  public canShowSettingsTab() {
    return this.user && this.user.role_alternate_name === 'basicUser';
  }

  public canShowTab() {
    return this.user && (this.user.role_alternate_name === 'basicUser' ||
      this.user.role_alternate_name === 'technicalManager');
  }
}
